module.exports = __webpack_public_path__ + "static/media/materialdesignicons-webfont.8babd018.svg";